import MuffinIcon from "./MuffinIcon";

export default function MuffinRating({ value, testid }) {
    if (value == null) {
        return (
            <span className="f-detail italic text-sm text-[#8a6d4a]" data-testid={testid}>
                votazione in arrivo
            </span>
        );
    }
    return (
        <span className="inline-flex items-center gap-1.5" data-testid={testid} aria-label={`${value} muffin su 10`}>
            <span className="flex items-center">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                    <MuffinIcon key={n} filled={n <= value} />
                ))}
            </span>
            <span className="f-title text-[11px] font-bold text-[#7a5a2e]">{value}/10</span>
        </span>
    );
}
